export const INSPIRATION_SLIDES = [
  {
    id: 'impossible-selfies',
    image: 'https://assets.ai-pro.org/assets/homepage/imgs/Make%20impossible%20selfies.jpg',
    caption: 'Make impossible selfies',
  },
  {
    id: 'photo-figurines',
    image: 'https://assets.ai-pro.org/assets/homepage/imgs/Turn%20your%20photos%20into%20figurines.jpg',
    caption: 'Turn your photos into figurines',
  },
  {
    id: 'nostalgic-mall',
    image: 'https://assets.ai-pro.org/assets/homepage/imgs/Create%20nostalgic%20mall%20pics.jpg',
    caption: 'Create nostalgic mall pics',
  },
  {
    id: 'ai-portraits',
    image: 'https://assets.ai-pro.org/assets/homepage/imgs/Combine%20photos.jpg',
    caption: 'Create stunning AI portraits',
  },
  {
    id: 'creative-transforms',
    image: 'https://assets.ai-pro.org/assets/homepage/imgs/Try%20out%20infinite%20hairstyles.jpg',
    caption: 'Transform photos into art',
  },
];

